import React from "react";
import { Table } from "react-bootstrap";

export default class IssueStatusReport extends React.Component {
  render() {
    const { misData } = this.props;
    return (
      <Table responsive striped hover size="sm" className="mis-project-list">
        <thead>
          <tr>
            <th className="first-child">Status</th>
            <th className="last-child">Number of Issues</th>
          </tr>
        </thead>
        <tbody>
          {misData &&
            misData.data &&
            misData.data.map((data, index) => {
              return (
                <tr key={index}>
                  <td className="child-between" title={data.name}>
                    {data.name}
                  </td>
                  <td className="last-child">{data.number}</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    );
  }
}
